module.exports = __webpack_public_path__ + "media/images/gateway/gocoin-782a7f0edae9ea8e46415680dd8995e1.png";